<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['ad.name']">
              <a-input v-model="queryParam.name" :placeholder="this.language['ad.must.name']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['eletronicSigned.affiliationApplication']">
              <a-select v-model="queryParam.applicationId" allowClear >
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.id">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['ad.status']">
              <j-dict-select-tag  v-model="queryParam.status"  :type="'radio'" dictCode="ad_status"/>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

    </div>
    <!-- 查询区域-END -->





    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{this.language['common.insertButton']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
        </div>


      <a-table
        ref="table"
        size="middle"
        :scroll="{x:1200}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">


        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
<!--        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" @click="aa(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>-->


        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            :title="language['ad.image']"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>




        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}}<a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.look']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <sys-bm-ad-modal ref="modalForm" @ok="modalFormOk"></sys-bm-ad-modal>
  </a-card>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysBmAdModal from './modules/SysBmAdModal'

  export default {
    name: 'SysBmAdList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SysBmAdModal
    },
    data () {
      return {
        description: '广告表管理页面',
        url: {
          list: "/sys/ad/list",
          delete: "/sys/ad/delete",
          deleteBatch: "/sys/ad/deleteBatch"

        },
        applicationCode:'platform',
        dictOptions:{},
        superFieldList:[],
        applicationList:{},
        previewVisible: false,
        previewImage: '',
      }
    },
    created() {
      this.getApplicationList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['eletronicSigned.affiliationApplication'],
              align:"center",
              dataIndex: 'applicationName',
              width: 200
            },
            {
              title:this.language['ad.position'],
              width: 300,
              align:"center",
              dataIndex: 'adPositionName',
              ellipsis: true
            },
            {
              title:this.language['ad.type'],
              width: 120,
              align:"center",
              dataIndex: 'fileTypeName'
            },
            {
              title:this.language['ad.name'],
              ellipsis:true,
              width:300,
              align:"center",
              dataIndex: 'name'
            },
            {
              title:this.language['ad.file'],
              width: 250,
              ellipsis:true,
              align:"center",
              dataIndex: 'imageUrl',
              scopedSlots: {customRender: "imgSlot"}
            }
            ,
            {
              title:this.language['ad.status'],
              width: 100,
              align:"center",
              dataIndex: 'statusName'
            },
            {
              title:this.language['common.sort'],
              align:"center",
              dataIndex: 'sortNo'
            },
            {
              title:this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              width:147,
              fixed: 'right',
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }
    },
    methods: {
      initDictConfig(){
      },

      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      getApplicationList(){
        httpAction("/sys/role/getSysBmApplication", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>